<!--
 * @Author: your name
 * @Date: 2020-10-16 08:52:44
 * @LastEditTime: 2020-10-29 10:06:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/views/workLocation/components/search.vue
-->
<template>
  <div class="work-search">
    <Input
      class="work-search-input"
      :maxlength="50"
      search
      v-model="keyWord"
      @on-enter="searchHandle"
      @on-search="searchHandle"
      @on-change="searchChange"
      enter-button="搜索"
      :placeholder="plNmae"
    />
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    plNmae: {
      type: String,
      default: '请输入职位或公司名称',
    },
  },
  data() {
    return {
      keyWord: '',
    }
  },
  methods: {
    searchHandle() {
      if (!this.keyWord) {
        this.$Message.warning('请输入搜索的内容！')
        return false
      }
      this.$emit('search', this.keyWord)
    },
    searchChange(val) {
      console.log(this.keyWord)
      if (!this.keyWord) {
        this.$emit('search', '')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.work-search {
  width: 100%;
  text-align: center;
  /deep/ .work-search-input {
    width: 780px;
    height: 48px;
    margin: 0 auto;
    .ivu-input {
      height: 48px;
      border: 1px solid #d6d6d6;
      font-size: 15px;
      &::placeholder {
        font-size: 15px;
      }
    }
    .ivu-input-search {
      background: #e56a69 !important;
      font-size: 16px;
      width: 114px;
      border: 1px solid #e56a69 !important;
    }
  }
}
</style>
